import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube, Twitter, Linkedin, Music2 } from "lucide-react";
import { BOOK_URL } from "../data/mock";
import { ScallopDivider } from "./Decor";

const socials = [
  { icon: Facebook, label: "Facebook" },
  { icon: Instagram, label: "Instagram" },
  { icon: Youtube, label: "YouTube" },
  { icon: Twitter, label: "X" },
  { icon: Music2, label: "TikTok" },
  { icon: Linkedin, label: "LinkedIn" },
];

const Footer = () => {
  return (
    <footer data-testid="site-footer">
      <div className="bg-[#63c79a] h-16 sm:h-24" />
      <div className="bg-white -mt-px">
        <ScallopDivider color="#63c79a" />
      </div>

      <div className="bg-white pt-12 pb-12 text-center">
        <h3 className="font-serif text-3xl sm:text-4xl font-bold text-[#1b8bc9] mb-8" style={{ fontFamily: "Literata, serif" }}>
          Follow us!
        </h3>
        <div className="flex items-center justify-center gap-4 flex-wrap px-4">
          {socials.map(({ icon: Icon, label }) => (
            <a
              key={label}
              href="#"
              aria-label={label}
              onClick={(e) => e.preventDefault()}
              className="w-12 h-12 rounded-full bg-[#1b8bc9] text-white flex items-center justify-center hover:bg-[#e5356f] hover:-translate-y-1 transition-[background-color,transform] duration-200 shadow"
            >
              <Icon size={22} />
            </a>
          ))}
        </div>
      </div>

      <div className="bg-[#e9f9fd] py-14">
        <div className="max-w-6xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-10 text-[15px]">
          <div className="flex flex-col gap-3">
            <Link to="/about" className="hover:text-[#e5356f] font-medium text-gray-800">About the book</Link>
            <Link to="/about#author" className="hover:text-[#e5356f] font-medium text-gray-800">About Ken Bossard</Link>
            <a href={BOOK_URL} target="_blank" rel="noreferrer" className="hover:text-[#e5356f] font-medium text-gray-800">Get the book</a>
            <Link to="/privacy" className="hover:text-[#e5356f] font-medium text-gray-800" data-testid="footer-privacy-link">Privacy policy</Link>
            <Link to="/panda" className="hover:text-[#e5356f] font-medium text-gray-800">Create your panda</Link>
          </div>
          <div className="flex flex-col gap-3">
            <Link to="/family" className="hover:text-[#e5356f] font-medium text-gray-800">Family dashboard</Link>
            <Link to="/certificates" className="hover:text-[#e5356f] font-medium text-gray-800">Certificate wall</Link>
            <Link to="/parents/fundamentals" className="hover:text-[#e5356f] font-medium text-gray-800">Parents' Area</Link>
            <Link to="/parents/facts" className="hover:text-[#e5356f] font-medium text-gray-800">Corrected facts sheet</Link>
            <Link to="/parents/glossary" className="hover:text-[#e5356f] font-medium text-gray-800">Glossary</Link>
            <Link to="/parents/resources" className="hover:text-[#e5356f] font-medium text-gray-800">Resources</Link>
            <Link to="/parents/worksheets" className="hover:text-[#e5356f] font-medium text-gray-800">Printable worksheets</Link>
          </div>
          <div className="flex flex-col gap-3">
            <Link to="/lessons" className="hover:text-[#e5356f] font-medium text-gray-800">All lessons</Link>
            <Link to="/lessons/promise-jars" className="hover:text-[#e5356f] font-medium text-gray-800">Ages 5-8</Link>
            <Link to="/lessons/saving-and-borrowing" className="hover:text-[#e5356f] font-medium text-gray-800">Ages 9-11</Link>
            <Link to="/lessons/score-explorers" className="hover:text-[#e5356f] font-medium text-gray-800">Ages 12-14</Link>
            <Link to="/lessons/profile-builders" className="hover:text-[#e5356f] font-medium text-gray-800">Ages 15-17</Link>
            <Link to="/lessons/independent-credit" className="hover:text-[#e5356f] font-medium text-gray-800">Ages 18-24</Link>
          </div>
          <div className="col-span-2 md:col-span-1 text-sm text-gray-600 leading-relaxed">
            <p className="font-bold text-gray-800 mb-2">A note on accuracy</p>
            <p>
              Credit scoring models and lender guidelines change over time. Figures on this site are talking points for family conversations, not loan advice. Verify current numbers with a licensed loan officer.
            </p>
          </div>
        </div>
        <div className="max-w-6xl mx-auto px-6 mt-12 pt-6 border-t border-[#c9ecf5] flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gray-500">
          <p>&copy; {new Date().getFullYear()} Teach Your Child Credit. Based on the book by Ken Bossard, MBA.</p>
          <p>Made for parents, grandparents, guardians, educators and mentors.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
